class AddressManager extends HTMLElement {
  connectedCallback() {
    this.modalWrapper = this.querySelector("#addressModal");
    this.form = this.querySelector("#addressForm");

    this.bindEvents();
  }

  bindEvents() {
    // OPEN (add/edit)
    this.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-action]");
      if (!btn) return;

      if (btn.dataset.action === "add") {
        this.openAdd();
      }

      if (btn.dataset.action === "edit") {
        this.openEdit(btn.dataset.id);
      }
    });

    // CLOSE
    this.querySelectorAll(".modal-close-btn, .modal-overlay")
      .forEach(el => el.addEventListener("click", () => this.closeModal()));

    // VALIDATION EVENTS
    this.bindValidation();

    // AJAX submit
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));

    // Delete Address
    const deleteForms = this.querySelectorAll('.delete-address-form');

    deleteForms.forEach((form) => {
      form.addEventListener('submit', this.handleDelete.bind(this));
    });

    // Address Type Selector
    const typeButtons = this.querySelectorAll('.address-type');
    const typeInput = this.querySelector('#addressType');

    typeButtons.forEach((button) => {
      button.addEventListener('click', () => {

        // remove active class
        typeButtons.forEach((btn) => {
          btn.classList.remove('active');
        });

        // add active class
        button.classList.add('active');

        // update hidden input
        typeInput.value = button.dataset.value;
      });
    });

    this.bindCountryProvince();
  }

  bindValidation() {
    this.requiredFields = [
      '#addressLabel',
      '#fullName',
      '#phone',
      '#address1',
      '#city',
      '#province',
      '#countryData'
    ];

    this.requiredFields.forEach((selector) => {
      const field = this.querySelector(selector);

      if (!field) return;

      field.setAttribute('required', true);

      field.addEventListener('input', () => {
        this.validateField(field);
      });

      field.addEventListener('change', () => {
        this.validateField(field);
      });
    });
  }

  validateForm() {
    let isValid = true;

    this.requiredFields.forEach((selector) => {
      const field = this.querySelector(selector);

      if (!field) return;

      const valid = this.validateField(field);

      if (!valid) {
        isValid = false;
      }
    });

    return isValid;
  }

  validateField(field) {
    const value = field.value.trim();

    // remove old error
    this.removeError(field);

    // required validation
    if (!value) {
      this.showError(field, 'This field is required');
      return false;
    }

    // phone validation
    if (field.id === 'phone') {
      const phoneRegex = /^[0-9+\-\s()]+$/;

      if (!phoneRegex.test(value)) {
        this.showError(field, 'Invalid phone number');
        return false;
      }
    }

    return true;
  }

  showError(field, message) {
    field.classList.add('field-error');

    const error = document.createElement('span');
    error.className = 'error-message';
    error.textContent = message;

    field.parentElement.appendChild(error);
  }

  removeError(field) {
    field.classList.remove('field-error');

    const error = field.parentElement.querySelector('.error-message');

    if (error) {
      error.remove();
    }
  }

  bindCountryProvince() {
    const countrySelect = this.querySelector('[name="address[country]"]');
    const provinceSelect = this.querySelector('[name="address[province]"]');

    if (!countrySelect || !provinceSelect) return;

    countrySelect.addEventListener("change", () => {
      this.loadProvinces(countrySelect, provinceSelect);
    });

    // initial load (edit form case)
    this.loadProvinces(countrySelect, provinceSelect);
  }

  loadProvinces(countrySelect, provinceSelect, selectedProvince = "") {
    const clone = this.querySelector("#country_clone");
    if (!clone) return;

    const selectedCountry = countrySelect.value;
    const selectedCountryLabel = countrySelect.options[countrySelect.selectedIndex].text;

    const option = Array.from(clone.options).find(opt => {
      const optValue = opt.value;
      const optLabel = opt.text;

      // console.log({
      //   optValue,
      //   optLabel,
      //   selectedCountry,
      //   selectedCountryLabel,
      //   a: (optLabel.trim() === selectedCountryLabel.trim())
      // });

      return (
        optLabel.trim() === selectedCountryLabel.trim()
      );
    });

    const provinces = JSON.parse(option?.dataset?.provinces || "[]");
    // console.log({provinces})
    // reset province select
    provinceSelect.innerHTML = "";

    if (!provinces.length) {
      provinceSelect.disabled = true;
      provinceSelect.innerHTML = `<option value="">---</option>`;
      return;
    }

    provinceSelect.disabled = false;

    provinces.forEach(([value, label]) => {
      const opt = document.createElement("option");
      opt.value = value;
      opt.textContent = label;
      if (value === selectedProvince) {
        opt.selected = true;
      }
      provinceSelect.appendChild(opt);
    });
  }

  openAdd() {
    this.form.reset();
    this.form.action = "/account/addresses";
    let method = this.form.querySelector('[name="_method"]');
    if (!method) {
        method = document.createElement("input");
        method.type = "hidden";
        method.name = "_method";
        this.form.appendChild(method);
    }
    method.value = "post";

    this.openModal();
  }

  openEdit(id) {
    const card = this.querySelector(`.address-card[data-id="${id}"]`);
    if (!card) return;
    
    const countrySelect = this.form.querySelector('[name="address[country]"]');
    const provinceSelect = this.form.querySelector('[name="address[province]"]');

    this.loadProvinces(
      countrySelect,
      provinceSelect,
      card.dataset.province || ""
    );

    const companyData = card.dataset.company;
    let typeValue = "Home";
    let addressLabel = "";

    if (companyData.includes("|")) {
      const parts = companyData.split("|").map(item => item.trim());

      typeValue = parts[0] || "Home";
      addressLabel = parts[1] || "";
    } else {
      addressLabel = companyData;
    }

    this.form.querySelector('#addressType').value = typeValue;

    const typeButtons = this.querySelectorAll('.address-type');

    typeButtons.forEach((btn) => {
      btn.classList.toggle(
        'active',
        btn.dataset.value === typeValue
      );
    });

    // change form action
    this.form.action = `/account/addresses/${id}`;
    this.form.dataset.id = id;

    // fill fields
    this.form.querySelector('[name="address[company]"]').value = addressLabel || "";
    this.form.querySelector('[name="address[name]"]').value = card.dataset.name || "";
    this.form.querySelector('[name="address[phone]"]').value = card.dataset.phone || "";
    this.form.querySelector('[name="address[address1]"]').value = card.dataset.address1 || "";
    this.form.querySelector('[name="address[address2]"]').value = card.dataset.address2 || "";
    this.form.querySelector('[name="address[city]"]').value = card.dataset.city || "";

    this.form.querySelector('[name="address[province]"]').value = card.dataset.province || "";
    this.form.querySelector('[name="address[country]"]').value = card.dataset.country || "";
    // console.log(card.dataset.default, card.dataset.default==="default")
    this.form.querySelector('[name="address[default]"]').checked = card.dataset.default === "default";

    let method = this.form.querySelector('[name="_method"]');
    if (!method) {
        method = document.createElement("input");
        method.type = "hidden";
        method.name = "_method";
        this.form.appendChild(method);
    }
    method.value = "put";
    this.openModal();
  }

  openModal() {
    this.modalWrapper.classList.remove("hidden");
    document.body.classList.add("opening-modal");
  }

  closeModal() {
    this.modalWrapper.classList.add("hidden");
    document.body.classList.remove("opening-modal");
  }

  async handleSubmit(e) {
    e.preventDefault();

    // VALIDATE FIRST
    const isValid = this.validateForm();

    if (!isValid) {
      return;
    }

    const formData = new FormData(this.form);

    // convert form data to API body
    const method = formData.get('_method') || "";
    const nameParts = (formData.get('address[name]') || "").trim().split(" ");

    let firstName = "";
    let lastName = "";

    if (nameParts.length === 1) {
      firstName = nameParts[0];
    } else if (nameParts.length > 1) {
      firstName = nameParts.slice(0, -1).join(" ");
      lastName = nameParts.slice(-1)[0];
    }

    const type = formData.get('address[type]') || "";
    const company = formData.get('address[company]') || "";

    let companyValue = "";

    if (type && company) {
      companyValue = `${type} | ${company}`;
    } else if (type) {
      companyValue = `${type} |`;
    } else if (company) {
      companyValue = company;
    }

    const body = {
      address: {
        firstName: firstName || "",
        lastName: lastName || "",
        company: companyValue,
        address1: formData.get('address[address1]') || "",
        address2: formData.get('address[address2]') || "",
        city: formData.get('address[city]') || "",
        province: formData.get('address[province]') || "",
        country: formData.get('address[country]') || "",
        zip: formData.get('address[zip]') || "",
        phone: formData.get('address[phone]') || ""
      },
      setAsDefault: formData.get('address[default]') === 'on'
    };

    const email = formData.get('email') || "";
    const store = formData.get('store') || "aisl-mall-dev";
    const api = formData.get('api') || "https://ldy22vg3ig.execute-api.ap-southeast-1.amazonaws.com/v1/api";
    let url = "";
    let fetchMethod = "POST";
    let addressId = "";

    if (method === "post") {
      url = `${api}/addresses?email=${email}&store=${store}`;
    }

    if (method === "put") {
      addressId = this.form.dataset.id;
      url = `${api}/addresses/${addressId}?email=${email}&store=${store}`;
      fetchMethod = "PUT";
    }

    // console.log({method, body, email, store, addressId, url, fetchMethod});

    try {
      const response = await fetch(url, {
        method: fetchMethod,
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (response.ok && data.success) {
        window.location.reload();
      } else {
        console.log("API error:", data);
        alert(data?.message || "Something went wrong.");
      }

    } catch (error) {
      console.error("Network error:", error);
      alert("Something went wrong. Please try again.");
    }
    
  }

  async handleDelete(event) {
    event.preventDefault();

    const form = event.currentTarget;

    const confirmed = confirm('Delete this address?');

    if (!confirmed) return;

    const addressId = form.dataset.id;
    const email = form.dataset.email;
    const store = form.dataset.store;
    const api = form.dataset.api;

    try {
      const response = await fetch(`${api}/addresses/${addressId}?email=${email}&store=${store}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: "include"
      });
      
      const data = await response.json();

      if (response.ok && data.success) {
        window.location.reload();
      } else {
        console.log("API error:", data);
        alert(data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error(error);
      alert('Something went wrong.');
    }
  }
}

customElements.define("address-manager", AddressManager);